export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';

// #region LocalStorage 
export const RETRIEVE_LOCAL_DATA = 'masar::verify-local-data';
export const SET_LOCAL_DATA = 'masar::set-local-data';
export const RESET_LOCAL_DATA = 'masar::reset-local-data';
// #endregion

// #region Projects
export const REQUEST_PROJECTS = 'masar::request-projects';
export const REQUEST_PROJECTS_FULLFILED = 'masar::request-projects-fullfiled';
export const ABORT_REQUEST_PROJECTS = 'masar::abort-request-projects';
export const THROW_REQUEST_PROJECTS_ERROR = 'masar::throw-request-projects-error';
export const REQUEST_CREATE_PROJECT = 'masar::request-create-project';
export const REQUEST_CREATE_PROJECT_FULLFILED = 'masar::request-create-project-fullfiled';
export const THROW_REQUEST_CREATE_PROJECT_ERROR = 'masar::throw-request-create-project-error';
export const UPDATE_PROJECTS_LIST = 'masar::update-projects-list';
// #endregion

// #region Users
export const REQUEST_USERS = 'masar::request-users';
export const REQUEST_USERS_FULLFILED = 'masar::request-users-fullfiled';
export const ABORT_REQUEST_USERS = 'masar::abort-request-users';
export const THROW_REQUEST_USERS_ERROR = 'masar::throw-request-users-error';
export const REQUEST_CREATE_USER = 'masar::request-create-user';
export const REQUEST_CREATE_USER_FULLFILED = 'masar::request-create-user-fullfiled';
export const THROW_REQUEST_CREATE_USER_ERROR = 'masar::throw-request-create-user-error';
export const UPDATE_USERS_LIST = 'masar::update-users-list';
// #endregion

// #region Resources
export const REQUEST_RESOURCES = 'masar::request-resources';
export const REQUEST_RESOURCES_FULLFILED = 'masar::request-resources-fullfiled';
export const ABORT_REQUEST_RESOURCES = 'masar::abort-request-resources';
export const THROW_REQUEST_RESOURCES_ERROR = 'masar::throw-request-resources-error';
export const REQUEST_CREATE_RESOURCE = 'masar::request-create-resource';
export const REQUEST_CREATE_RESOURCE_FULLFILED = 'masar::request-create-resource-fullfiled';
export const THROW_REQUEST_CREATE_RESOURCE_ERROR = 'masar::throw-request-create-resource-error';
export const UPDATE_RESOURCES_LIST = 'masar::update-resources-list';
// #endregion

// #region Dictionaries
export const REQUEST_DICTIONARIES = 'masar::request-dictionaries';
export const REQUEST_DICTIONARIES_FULLFILED = 'masar::request-dictionaries-fullfiled';
export const ABORT_REQUEST_DICTIONARIES = 'masar::abort-request-dictionaries';
export const THROW_REQUEST_DICTIONARIES_ERROR = 'masar::throw-request-dictionaries-error';
export const REQUEST_CREATE_DICTIONARY = 'masar::request-create-dictionary';
export const REQUEST_CREATE_DICTIONARY_FULLFILED = 'masar::request-create-dictionary-fullfiled';
export const THROW_REQUEST_CREATE_DICTIONARY_ERROR = 'masar::throw-request-create-dictionary-error';
export const UPDATE_DICTIONARIES_LIST = 'masar::update-dictionaries-list';
// #endregion

// #region Glossary
export const REQUEST_GLOSSARY = 'masar::request-glossary';
export const REQUEST_GLOSSARY_FULLFILED = 'masar::request-glossary-fullfiled';
export const ABORT_REQUEST_GLOSSARY = 'masar::abort-request-glossary';
export const THROW_REQUEST_GLOSSARY_ERROR = 'masar::throw-request-glossary-error';
// #endregion

// #region Organizations
export const REQUEST_ORGANIZATIONS = 'masar::request-organizations';
export const REQUEST_ORGANIZATIONS_FULLFILED = 'masar::request-organizations-fullfiled';
export const ABORT_REQUEST_ORGANIZATIONS = 'masar::abort-request-organizations';
export const THROW_REQUEST_ORGANIZATIONS_ERROR = 'masar::throw-request-organizations-error';
export const REQUEST_CREATE_ORGANIZATION = 'masar::request-create-organization';
export const REQUEST_CREATE_ORGANIZATION_FULLFILED = 'masar::request-create-organization-fullfiled';
export const THROW_REQUEST_CREATE_ORGANIZATION_ERROR = 'masar::throw-request-create-organization-error';
export const UPDATE_ORGANIZATIONS_LIST = 'masar::update-organizations-list';
// #endregion

// #region Reading List
export const REQUEST_READING_LIST = 'masar::request-reading-list';
export const REQUEST_READING_LIST_FULLFILED = 'masar::request-reading-list-fullfiled';
export const ABORT_REQUEST_READING_LIST = 'masar::abort-request-reading-list';
export const THROW_REQUEST_READING_LIST_ERROR = 'masar::throw-request-reading-list-error';
export const REQUEST_CREATE_READING_LIST = 'masar::request-create-reading-list';
export const REQUEST_CREATE_READING_LIST_FULLFILED = 'masar::request-create-reading-list-fullfiled';
export const THROW_REQUEST_CREATE_READING_LIST_ERROR = 'masar::throw-request-create-reading-list-error';
export const UPDATE_READING_LIST = 'masar::update-reading-list';
export const ACCEPT_READING_LIST_REQUEST = 'masar::accept-reading-list-request';
export const REJECT_READING_LIST_REQUEST = 'masar::reject-reading-list-request';
// #endregion



// WEBPACK FOOTER //
// ./src/types/index.js